export default {"src":"/_next/static/media/LandscapeButton.fe1a86f5.svg","height":29,"width":44,"blurWidth":0,"blurHeight":0};